import React from 'react';

import { BaseIcon, Props as BaseIconProps } from './BaseIcon';
import { ReactComponent as AddSvgComponent } from './svgs/add.svg';
import { ReactComponent as arrowSolidSvgComponent } from './svgs/arrow-solid.svg';
import { ReactComponent as ArrowSvgComponent } from './svgs/arrow.svg';
import { ReactComponent as CameraComponent } from './svgs/camera.svg';
import { ReactComponent as checkSvgComponent } from './svgs/check.svg';
import { ReactComponent as checkmarkThinSvgComponent } from './svgs/checkmark-thin.svg';
import { ReactComponent as ChevronSvgComponent } from './svgs/chevron.svg';
import { ReactComponent as clearFilesSvgComponent } from './svgs/clearFiles.svg';
import { ReactComponent as clockComponent } from './svgs/clock.svg';
import { ReactComponent as closeThinSvgComponent } from './svgs/close-thin.svg';
import { ReactComponent as fileSvgComponent } from './svgs/document.svg';
import { ReactComponent as dotsSvgComponent } from './svgs/dots.svg';
import { ReactComponent as editSvgComponent } from './svgs/edit.svg';
import { ReactComponent as editPromptComponent } from './svgs/editDeliverable.svg';
import { ReactComponent as expandSvgComponent } from './svgs/expand.svg';
import { ReactComponent as folderComponent } from './svgs/folder.svg';
import { ReactComponent as gradientCheckSvgComponent } from './svgs/gradientCheck.svg';
import { ReactComponent as gridSvgComponent } from './svgs/grid.svg';
import { ReactComponent as collectLogoComponent } from './svgs/icon-collect.svg';
import { ReactComponent as pasteLogoComponent } from './svgs/icon-paste.svg';
import { ReactComponent as wetransferLogoComponent } from './svgs/icon-wt.svg';
import { ReactComponent as infoComponent } from './svgs/info.svg';
import { ReactComponent as linkComponent } from './svgs/link.svg';
import { ReactComponent as listSvgComponent } from './svgs/list.svg';
import { ReactComponent as lockComponent } from './svgs/lock.svg';
import { ReactComponent as MultiplySvgComponent } from './svgs/multiply.svg';
import { ReactComponent as OpenLinkComponent } from './svgs/open-link.svg';
import { ReactComponent as previewSvgComponent } from './svgs/preview.svg';
import { ReactComponent as shareSvgComponent } from './svgs/share.svg';
import { ReactComponent as trashSvgComponent } from './svgs/trash.svg';
import { ReactComponent as uploadCloudSvgComponent } from './svgs/uploadCloud.svg';

export type Props = Omit<BaseIconProps, 'svg'>;

export const IconAdd: React.FC<Props> = (props) => (
  <BaseIcon svg={AddSvgComponent} {...props} />
);

export const IconMultiply: React.FC<Props> = (props) => (
  <BaseIcon svg={MultiplySvgComponent} {...props} />
);

export const IconArrow: React.FC<Props> = (props) => (
  <BaseIcon svg={ArrowSvgComponent} {...props} />
);

export const IconClearFiles: React.FC<Props> = (props) => (
  <BaseIcon svg={clearFilesSvgComponent} {...props} />
);

export const IconExpand: React.FC<Props> = (props) => (
  <BaseIcon svg={expandSvgComponent} {...props} />
);

export const IconGrid: React.FC<Props> = (props) => (
  <BaseIcon svg={gridSvgComponent} {...props} />
);

export const IconList: React.FC<Props> = (props) => (
  <BaseIcon svg={listSvgComponent} {...props} />
);

export const IconShare: React.FC<Props> = (props) => (
  <BaseIcon svg={shareSvgComponent} {...props} />
);

export const IconTrash: React.FC<Props> = (props) => (
  <BaseIcon svg={trashSvgComponent} {...props} />
);

export const IconPreview: React.FC<Props> = (props) => (
  <BaseIcon svg={previewSvgComponent} {...props} />
);

export const IconChevron: React.FC<Props> = (props) => (
  <BaseIcon svg={ChevronSvgComponent} {...props} />
);

export const IconUploadCloud: React.FC<Props> = (props) => (
  <BaseIcon svg={uploadCloudSvgComponent} {...props} />
);

export const IconCheck: React.FC<Props> = (props) => (
  <BaseIcon svg={checkSvgComponent} {...props} />
);

export const IconCheckmarkThin: React.FC<Props> = (props) => (
  <BaseIcon svg={checkmarkThinSvgComponent} {...props} />
);

export const IconCloseThin: React.FC<Props> = (props) => (
  <BaseIcon svg={closeThinSvgComponent} {...props} />
);

export const IconGradientCheck: React.FC<Props> = (props) => (
  <BaseIcon svg={gradientCheckSvgComponent} {...props} />
);

export const IconDots: React.FC<Props> = (props) => (
  <BaseIcon svg={dotsSvgComponent} {...props} />
);

export const IconEdit: React.FC<Props> = (props) => (
  <BaseIcon svg={editSvgComponent} {...props} />
);

export const IconFolder: React.FC<Props> = (props) => (
  <BaseIcon svg={folderComponent} {...props} />
);

export const IconFile: React.FC<Props> = (props) => (
  <BaseIcon svg={fileSvgComponent} {...props} />
);

export const IconLink: React.FC<Props> = (props) => (
  <BaseIcon svg={linkComponent} {...props} />
);

export const IconClock: React.FC<Props> = (props) => (
  <BaseIcon svg={clockComponent} {...props} />
);

export const IconLock: React.FC<Props> = (props) => (
  <BaseIcon svg={lockComponent} {...props} />
);

export const IconInfo: React.FC<Props> = (props) => (
  <BaseIcon svg={infoComponent} {...props} />
);

export const IconEditPrompt: React.FC<Props> = (props) => (
  <BaseIcon svg={editPromptComponent} {...props} />
);

export const IconWeTransfer: React.FC<Props> = (props) => (
  <BaseIcon svg={wetransferLogoComponent} {...props} />
);

export const IconCollect: React.FC<Props> = (props) => (
  <BaseIcon svg={collectLogoComponent} {...props} />
);

export const IconPaste: React.FC<Props> = (props) => (
  <BaseIcon svg={pasteLogoComponent} {...props} />
);

export const IconOpenLink: React.FC<Props> = (props) => (
  <BaseIcon
    svg={OpenLinkComponent}
    aria-label="open link"
    {...props}
    viewBox="0 0 11 12"
  />
);

export const IconCamera: React.FC<Props> = (props) => (
  <BaseIcon svg={CameraComponent} {...props} viewBox="0 0 40 40" />
);

export const IconArrowSolid: React.FC<Props> = (props) => (
  <BaseIcon
    svg={arrowSolidSvgComponent}
    {...props}
    width="12"
    height="12"
    viewBox="0 0 12 12"
  />
);
